import React from 'react'

function Footer() {
    return (
        <footer>
            <h1>Created By <span>ZAINUDDIN</span></h1>
        </footer>
    )
}

export default Footer
